import {userConstants} from '../../_constants';

export function listTemplateDelivery(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_LIST_TEMPLATE_DELIVERY_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_LIST_TEMPLATE_DELIVERY_SUCCESS:
      return {
        /*loading: false,
        dataTemplateDelivery: action.data,*/
        ...action.data,
      };
    case userConstants.GET_LIST_TEMPLATE_DELIVERY_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
